import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareCapacityRoute: InvariantJiraRoute = {
	name: 'software-capacity',
	path: '/jira/software/projects/:projectKey/boards/:boardId/capacity/:view(people|work)?',
	query: [],
};
